/* Verhuisd uit sections/single-product.liquid: stond als inline script in het
   document (parse vóór de eerste paint). Liquid-waarden komen uit window.FLORAFY_PDP,
   gezet door de sectie vlak vóór deze scripts. */
var cfg = window.FLORAFY_PDP || {};
(function() {
  'use strict';

  function initThumbnailNav() {
    const mainSlider = document.querySelector('.js-product-hero-main-slider');
    const thumbNav = document.querySelector('.js-product-hero-main-nav');

    if (!mainSlider || !thumbNav) {
      console.log('[Thumb Nav] No slider or nav found');
      return;
    }

    const thumbSlides = thumbNav.querySelectorAll('.product-hero-main-nav__slide');
    if (thumbSlides.length === 0) {
      console.log('[Thumb Nav] No thumbnail slides found');
      return;
    }

    console.log('[Thumb Nav] Initializing with', thumbSlides.length, 'thumbnails');

    // Set first thumbnail as active
    thumbSlides[0].classList.add('is-active');

    // Function to navigate to slide (waits for Slick if needed)
    function goToSlide(index) {
      if (typeof $ === 'undefined') {
        console.log('[Thumb Nav] jQuery not available');
        return;
      }

      var $slider = $(mainSlider);

      // Check if Slick is initialized
      if ($slider.hasClass('slick-initialized')) {
        console.log('[Thumb Nav] Navigating to slide', index);
        $slider.slick('slickGoTo', index);
      } else {
        // Wait for Slick to initialize (retry up to 10 times)
        console.log('[Thumb Nav] Waiting for Slick...');
        var attempts = 0;
        var waitForSlick = setInterval(function() {
          attempts++;
          if ($slider.hasClass('slick-initialized')) {
            clearInterval(waitForSlick);
            console.log('[Thumb Nav] Slick ready, navigating to slide', index);
            $slider.slick('slickGoTo', index);
          } else if (attempts >= 10) {
            clearInterval(waitForSlick);
            console.log('[Thumb Nav] Slick not ready after 10 attempts');
          }
        }, 100);
      }
    }

    // Handle thumbnail clicks
    thumbSlides.forEach(function(thumb, index) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        console.log('[Thumb Nav] Thumbnail clicked:', index);

        // Update active state immediately
        thumbSlides.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        // Navigate main slider
        goToSlide(index);
      });
    });

    // Sync thumbnail active state when main slider changes
    if (typeof $ !== 'undefined') {
      // Wait for Slick and bind afterChange
      var bindSlickEvents = function() {
        var $slider = $(mainSlider);
        if ($slider.hasClass('slick-initialized')) {
          $slider.on('afterChange', function(event, slick, currentSlide) {
            console.log('[Thumb Nav] Main slider changed to:', currentSlide);
            thumbSlides.forEach(function(t) { t.classList.remove('is-active'); });
            if (thumbSlides[currentSlide]) {
              thumbSlides[currentSlide].classList.add('is-active');

              // Scroll thumbnail into view
              thumbSlides[currentSlide].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
              });
            }
          });
          console.log('[Thumb Nav] Bound afterChange event');
        } else {
          // Retry after 200ms
          setTimeout(bindSlickEvents, 200);
        }
      };
      bindSlickEvents();
    }

    console.log('[Thumb Nav] Initialization complete');
  }

  // Sync thumbnail container height with main image (for mobile/tablet)
  function syncThumbnailHeight() {
    var mainSlider = document.querySelector('.product-hero-main-slider');
    var thumbNav = document.querySelector('.product-hero-main-nav');

    if (!mainSlider || !thumbNav) return;

    // Get the actual rendered height of the main slider
    var mainHeight = mainSlider.offsetHeight;
    if (mainHeight > 0) {
      thumbNav.style.setProperty('--main-image-height', mainHeight + 'px');
      console.log('[Thumb Nav] Synced height:', mainHeight + 'px');
    }
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Small delay to ensure Slick has time to initialize
      setTimeout(initThumbnailNav, 300);
      // Sync heights after images load
      setTimeout(syncThumbnailHeight, 100);
      window.addEventListener('load', syncThumbnailHeight);
      window.addEventListener('resize', syncThumbnailHeight);
    });
  } else {
    setTimeout(initThumbnailNav, 300);
    setTimeout(syncThumbnailHeight, 100);
    window.addEventListener('load', syncThumbnailHeight);
    window.addEventListener('resize', syncThumbnailHeight);
  }
})();
